import * as Yup from "yup";

export type employeeDeptFilter = {
  name: string;
  isTeaching: string;
  isLanguage: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const employeeDeptInitialValues: employeeDeptFilter = {
  name: "",
  isTeaching: "",
  isLanguage: "",
  created_at: [null, null],
  updated_at: [null, null],
};

export const employeeDeptValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});

export const employeeDeptProperties = [
  {
    id: "name",
    type: "text",
    label: "Name",
    placeholder: "Enter Department Name",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
  {
    id: "isTeaching",
    type: "normal-select",
    label: "Is Teaching",
    options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
    ],
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
  {
    id: "isLanguage",
    type: "normal-select",
    label: "Is Language",
    options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
    ],
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj: any, keys: string[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
